/** 並び順キーを左から比べる。確定済みHTMLの cmpKey と同一。 */
export function compareKeys(a, b) {
    const len = Math.max(a.length, b.length);
    for (let i = 0; i < len; i++) {
        const x = a[i] ?? 0;
        const y = b[i] ?? 0;
        if (x === y)
            continue;
        if (typeof x === 'number' && typeof y === 'number')
            return x < y ? -1 : 1;
        if (typeof x === 'string' && typeof y === 'string')
            return x < y ? -1 : 1;
        // 数値と文字列が同じ桁に来る使い方はしないが、混ざっても順序が揺れないよう数値を先に置く
        return typeof x === 'number' ? -1 : 1;
    }
    return 0;
}
export function sortByKey(items, key) {
    return [...items].sort((a, b) => compareKeys(key(a), key(b)));
}
const CLERK_TYPE_RANK = { change: 0, confirm: 1, stop: 2 };
/**
 * 各リストの並び順。確定済みHTMLの KEY と一対一で対応する。
 * 調製前は「変更 → 確定 → 中止 → 入力前」の順で、同じ種別の中では確定が出た順（seq昇順）。
 * 入力前は名簿順で末尾に並べる。
 *
 * seq を使うキーは採番が全案件で一意なので、それだけで全順序になる。
 * rosterIndex を使う todo と rxWait・nWait の入力待ちだけは同値があり得るため、
 * 代理キーを末尾に足して決着させる（DB側の一意制約が壊れても表示順は揺れない）。
 */
export const ORDER = {
    /** 外来：入力前は名簿順 */
    todo: (c) => [c.rosterIndex, c.surrogateKey],
    /** 外来：入力済みは新しい順 */
    done: (c) => [-(c.clerk?.seq ?? 0)],
    /** 薬剤部：調製前 */
    rxWait: (c) => c.clerk ? [CLERK_TYPE_RANK[c.clerk.type], c.clerk.seq] : [3, c.rosterIndex, c.surrogateKey],
    /** 薬剤部：調製開始は古い順（いちばん前から待っている患者が一番上） */
    rxStarted: (c) => [c.pharm?.seq ?? 0],
    /** 薬剤部：調製完了は古い順 */
    rxDone: (c) => [c.pharmDone?.seq ?? 0],
    /** 薬剤部：中止（確認済）は新しい順 */
    rxStop: (c) => [-(c.stopAck?.seq ?? 0)],
    /** ケモ室：薬剤待ちは薬が早く届く順「調製完了 → 調製開始済み → 確定済み → 入力待ち」 */
    nWait: (c) => c.pharmDone
        ? [0, c.pharmDone.seq]
        : c.pharm
            ? [1, c.pharm.seq]
            : c.clerk
                ? [2, c.clerk.seq]
                : [3, c.rosterIndex, c.surrogateKey],
    /** ケモ室：投与中は古い順（いちばん前から投与している患者が一番上） */
    nAdmin: (c) => [c.admin?.seq ?? 0],
    /** ケモ室：投与完了は古い順 */
    nDone: (c) => [c.adminDone?.seq ?? 0],
    /** ケモ室：本日中止は新しい順 */
    nStop: (c) => [-(c.clerk?.seq ?? 0)],
    /** 大型モニタ：中止・調製開始・投与中はそれぞれ発生順。調製完了は調製開始の後ろにまとめる */
    monStopped: (c) => [c.clerk?.seq ?? 0],
    monMaking: (c) => [c.pharmDone ? 1 : 0, c.pharm?.seq ?? 0],
    monGiving: (c) => [c.admin?.seq ?? 0],
};
//# sourceMappingURL=ordering.js.map